import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AppSettings } from "../../config/config";
import { map } from "rxjs/operators";
import { apiConstants } from "../constant/apiConstant";

@Injectable()
export class NewLoginWithDomainServices {
  private url = AppSettings.API_ENDPOINT_V3;
  private verifySchoolDomainDetails = apiConstants.verifySchoolDomainDetails;
  constructor(private http: HttpClient) {}
  headers: HttpHeaders;
  verifySchoolDomainDetailsApi(body: any) {
    return this.http
      .post(`${this.url}${this.verifySchoolDomainDetails}`, body, {
        headers: this.headers,
      })
      .pipe(map((res) => res));
  }
}
